import { CommonCurrency } from './types';

export const INITIAL_FROM_AMOUNT = 1;
export const INITIAL_FROM_CURRENCY = CommonCurrency.EUR;
export const INITIAL_TO_CURRENCY = CommonCurrency.NOK;

export const INITIAL_RATES_FROM_TO_NOK = [
    CommonCurrency.DKK,
    CommonCurrency.SEK,
    CommonCurrency.EUR,
    CommonCurrency.USD,
];

export const MOST_COMMON_RATES: string[] = [
    CommonCurrency.NOK,
    CommonCurrency.DKK,
    CommonCurrency.SEK,
    CommonCurrency.EUR,
    CommonCurrency.USD,
];

// Backend amount length must be in range from 1 to 15
export const MAXIMUM_AMOUNT_LENGTH = 10000000000;
